import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/promotions/$initiativeId/national/create/')({
  beforeLoad: () => {
    throw redirect({ from: Route.fullPath, to: '..', replace: true })
  },
})
